/**
 * Which client workspace a platform super admin is working in. Sent as `X-Workspace-Id` on every
 * API call; the server ignores it for everyone else (their workspace comes from their login).
 *
 * localStorage is the single source of truth and is read on every call, so there is never a second,
 * stale copy (e.g. after a hot reload or in another tab). The in-memory value is only a fallback
 * for browsers where storage is unavailable.
 */
const KEY = 'kollabr.activeWorkspaceId';
let fallback: string | null = null;

export function getActiveWorkspaceId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return fallback;
  }
}

export function setActiveWorkspaceId(id: string | null): void {
  fallback = id;
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    // storage unavailable (private mode) — the fallback still works for this tab
  }
}
